import React from 'react';

import './mobile-experience-share-style.scss';

import MobileAppDownload from '@src/componentsNew/AppDownload/MobileAppDownload';

const MobileExperienceSharePage = ({ deepLink }) => {
  return (
    <div id="mobile-experience-share-wrapper">
      <MobileAppDownload deepLink={deepLink} infoText={`Maccaron Experience (M. E.)\navailable on the Maccaron App`} />
    </div>
  );
};

export default MobileExperienceSharePage;
